import script from "./ReportInventarisAssetView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportInventarisAssetView.vue?vue&type=script&setup=true&lang=js"

import "./ReportInventarisAssetView.vue?vue&type=style&index=0&id=3de81863&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de81863"]])

export default __exports__